/**
 * Функция сокращает переданную строку до указанного количества символов.
 * Если длина строки превышает заданное значение, она обрезается.
 * По умолчанию строка обрезается до 100 символов, но можно задать
 * другую длину через параметр to.
 *
 * @param {string} string Строка, которую нужно обрезать.
 * @param {number} [to=100] Длина, до которой нужно сократить строку (по умолчанию 100).
 * @returns {string} Обрезанная строка.
 *
 * @example
 * shortenString("Это длинная строка", 10)
 * // Вернёт: "Это длинн"
 */
export const shortenString = (string, to = 100) =>
  string.length > to ? string.slice(0, to) : string;
